import React, { Component } from 'react';
import whiteLOgo from "../../../../assets/img/logo-white-small.png"


class Error extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <>
        <div className="post-paid-common-container">
          <div className="container" style={{ background: 'none' }}>
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-12">
                <div className="card post-paid-common-card">
                  
                  {/* 404 Error Section */}
                  <div className="post-paid-common-error-container">
                      <div  className='common-error-logo' >
                  <img src={whiteLOgo} alt="Logo" />
                      </div>
                    
                    {/* Warning Icon */}
                    <div className="post-paid-common-error-icon">
                      <svg 
                        width="40" 
                        height="40" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="#ffa500" 
                        strokeWidth="3"
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <circle cx="12" cy="17" r="1"></circle>
                      </svg>
                    </div>

                    {/* Main Message */}
                    <h2 className="post-paid-common-error-title">
                      Hang tight
                    </h2>
                    
                    <p className="post-paid-common-error-subtitle">
                      {this.props?.error}
                    </p>

                    {/* Help Text */}
                    <div className="post-paid-common-error-help">
                      <h3 className="post-paid-common-error-help-title">
                        Let's get you back on track
                      </h3>
                      
                      <p className="post-paid-common-error-help-text">
                      Please ensure you enter the URL exactly as provided in the email. If the issue persists, contact your sales agent for a fresh link.
                      </p>
                    </div>

                    {/* Action Buttons */}
                    <div className="post-paid-common-error-actions">
               
                      
                      {/* Home Page Button */}
                      <div className="post-paid-common-error-action-item" style={{ cursor: "pointer" }}  onClick={() => window.location.href = "https://prepaid.telsim.com.au/"}>
                        <div className="post-paid-common-error-action-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                            <polyline points="9,22 9,12 15,12 15,22"></polyline>
                          </svg>
                        </div>
                        <div className="post-paid-common-error-action-label">
                          Home Page
                        </div>
                      </div>
                   

                      {/* Help & Support Button */}
                      <div className="post-paid-common-error-action-item" onClick={() => window.location.href = "https://www.telsim.com.au/faq/"}>
                        <div className="post-paid-common-error-action-icon post-paid-common-error-helpand-support">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                            <path d="M14 9V5a3 3 0 0 0-6 0v4"></path>
                            <rect x="2" y="9" width="20" height="12" rx="2" ry="2"></rect>
                            <circle cx="12" cy="15" r="1"></circle>
                          </svg>
                        </div>
                        <div className="post-paid-common-error-action-label  ">
                          Help & Support
                        </div>
                      </div>

                      {/* Contact Us Button */}
                      <div className="post-paid-common-error-action-item"  onClick={() => window.location.href = "https://www.telsim.com.au/contact-us/"}
                     style={{ cursor: "pointer" }}>
                        <div className="post-paid-common-error-action-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                          </svg>
                        </div>
                        <div className="post-paid-common-error-action-label">
                          Contact Us
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Error;